/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {

    ready() {
     
    },

    registered(registration) {

  

  registration.update();

},

    updatefound() {
    
    },

    updated(registration) {

  window.dispatchEvent(new CustomEvent('swUpdated', {
    detail: registration
  }));

},

    offline() {
      
    },

    error(error) {
      console.error("SW ERROR:", error);
    }

  });
}